module.exports = __webpack_public_path__ + "img/kickoff.64068d46.png";